<template>
	<div v-if="properties.length > 0">
		<vx-card class="mb-4" @click="handleClickSelect(data)" :key="index" v-for="(data, index) in properties">
			<template slot="actions" v-if="false">
				<div class="flex flex-row justify-between">
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
							<vs-button
								icon-pack="feather"
								icon="icon-x"
								color="primary"
								type="flat"
								radius
								@click.stop="() => {}"
							></vs-button>
						</vx-tooltip>
					</transition>
				</div>
			</template>

			<div class="vx-row">
				<div class="vx-col w-full">
					<label class="vs-input--label">{{ $t("Object.TypeField") }} </label>
					<vx-input-group prependClasses="border border-solid border-grey border-r-0">
						<template slot="prepend">
							<div class="prepend-text btn-addon">
								<vs-button
									class="btn-drop w-full"
									color="gray"
									size="large"
									:disabled="!enableEdit(data)"
								>
									<i class="material-icons inline-block mr-2">
										{{ icon(data) }}
									</i>
								</vs-button>
								<vs-dropdown vs-trigger-click class="cursor-pointer" v-show="enableEdit(data)">
									<a class="flex items-center ml-base mr-base text-dark" href.prevent>
										{{ label(data) }}
										<i class="material-icons ml-4">expand_more</i>
									</a>

									<vs-dropdown-menu>
										<vs-dropdown-group :vs-label="$t('Object.Basics')">
											<vs-dropdown-item
												v-for="fieldType in fieldTypes"
												:key="fieldType.value"
												@click="selectFieldType(fieldType, data)"
											>
												<div class="flex flex-wrap items-center">
													<i class="material-icons inline-block mr-2 p-1">
														{{ fieldType.icon }}
													</i>
													<span class="text-lg">{{ fieldType.label }}</span>
												</div>
											</vs-dropdown-item>
										</vs-dropdown-group>
									</vs-dropdown-menu>
								</vs-dropdown>
							</div>
						</template>

						<vs-input
							:disabled="!enableEdit(data)"
							size="large"
							:placeholder="$t('Object.Label') + ': ' + $t('Object.LabelHelp')"
							v-model.trim="data.label"
							@change="handleChange($event)"
							@keyup.13="addProperty"
							class="w-full"
							ref="property-label"
						/>
					</vx-input-group>
				</div>

				<div class="vx-col w-full mt-2 flex justify-center" v-if="data.type === 'text'">
					<vs-input-number
						v-show="enableEdit(data)"
						v-model.number="data.minLength"
						:label="$t('DesignConfig.MinimumCharacterLength') + ':'"
					/>
					<vs-input-number
						v-show="enableEdit(data)"
						v-model.number="data.maxLength"
						class="ml-base"
						:label="$t('DesignConfig.MaximumCharacterLength') + ':'"
					/>

					<div v-show="!enableEdit(data)" class="text-lg text-gray">
						<span>
							{{ $t("DesignConfig.MinimumCharacterLength") }}:
							<span class="font-semibold">{{ data.minLength }}</span></span
						>
						&nbsp;&nbsp;
						<span
							>{{ $t("DesignConfig.MaximumCharacterLength") }}:
							<span class="font-semibold">{{ data.maxLength }}</span>
						</span>
					</div>
				</div>

				<div class="vx-col w-full mt-2 flex justify-center" v-if="data.type === 'number'">
					<vs-input-number
						v-model.number="data.minimum"
						class="mr-base"
						:label="$t('DesignConfig.MinimumVal') + ':'"
					/>
					<vs-input-number
						v-model.number="data.maximum"
						class="ml-base"
						:label="$t('DesignConfig.MaximumVal') + ':'"
					/>
				</div>
			</div>

			<div class="vx-row" v-if="data.type === 'check' || data.type === 'radio'">
				<div class="vx-col w-full">
					<div class="mt-4" v-show="!enableEdit(data)">
						<small class="date-label">{{ $t("Options") }}</small>
						<ul class="centerx mt-4">
							<li v-for="(option, index) in data.options" :key="index">
								<vs-radio v-if="data.type === 'radio'" disabled>
									<span class="text-sm">{{ option }}</span>
								</vs-radio>
								<vs-checkbox v-else disabled
									><span class="text-sm">{{ option }}</span>
								</vs-checkbox>
								<vs-divider class="mt-2 mb-2"></vs-divider>
							</li>
						</ul>
					</div>
				</div>

				<div class="vx-col w-full" v-show="enableEdit(data)">
					<div class="mt-4">
						<small class="date-label">{{ $t("Options") }}</small>
						<vue-perfect-scrollbar class="scroll-area--content-options" :settings="settings">
							<vx-input-group
								v-for="(option, index) in data.options"
								:key="index"
								class="mb-1"
								prependClasses="border border-solid border-grey border-r-0"
							>
								<template slot="prepend">
									<div class="prepend-text">
										<feather-icon
											v-if="data.type === 'radio'"
											icon="CircleIcon"
											svgClasses="w-5 h-5 text-dark"
										/>
										<feather-icon v-else icon="CheckSquareIcon" svgClasses="w-5 h-5 text-dark" />
									</div>
								</template>

								<div class="flex">
									<vs-input
										v-model="data.options[index]"
										:placeholder="$t('DesignConfig.Option') + ' ' + (index + 1)"
										:value="option"
										@keyup.13="addOption"
										:ref="'option-' + data.id"
										class="w-full mr-1"
									/>
									<vs-button
										@click="removeOption(index)"
										icon-pack="feather"
										icon="icon-x"
										color="danger"
										type="flat"
										radius
									></vs-button>
								</div>
							</vx-input-group>
						</vue-perfect-scrollbar>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="data.type === 'check_obj'">
				<div class="vx-col w-full mt-base mb-2">
					<vs-button
						@click="activeFormatPrompt = true"
						icon-pack="feather"
						icon="icon-list"
						color="dark"
						type="flat"
						>{{ $t("DesignConfig.LoadOptions") }}</vs-button
					>
				</div>

				<div class="vx-col w-full">
					<div class="mt-4" v-show="!enableEdit(data)">
						<small class="date-label">{{ $t("Options") }}</small>
						<ul class="centerx mt-4">
							<li v-for="(option, index) in data.options_obj" :key="index">
								<div class="flex flex-row justify-between">
									<span class="text-sm">{{ option.label }}</span>
									<span class="text-sm mr-base">{{ option.value }}</span>
								</div>
								<vs-divider class="mt-2 mb-2"></vs-divider>
							</li>
						</ul>
					</div>
				</div>

				<div class="vx-col w-full" v-show="enableEdit(data)">
					<div class="mt-4">
						<small class="date-label">{{ $t("Options") }}</small>
						<vue-perfect-scrollbar class="scroll-area--content-options" :settings="settings">
							<vx-input-group
								v-for="(option, index) in data.options_obj"
								:key="index"
								class="mb-1"
								prependClasses="border border-solid border-grey border-r-0"
							>
								<template slot="prepend">
									<div class="prepend-text text-dark">
										<feather-icon icon="CheckSquareIcon" svgClasses="w-5 h-5 text-dark" />
									</div>
								</template>

								<div class="flex">
									<div class="w-full mr-1">
										<vs-input
											v-model="option.label"
											:placeholder="$t('Label')"
											:value="option.label"
											@keyup.13="addOptionCheckObj"
											:ref="'option-label-' + data.id"
											class="w-full mr-1"
										/>
									</div>
									<div>
										<vs-input
											v-model="option.value"
											:placeholder="$t('Value')"
											:value="option.value"
											:ref="'option-value' + data.id"
											class="w-full mr-1"
										/>
									</div>
									<vs-button
										@click="removeOptionObj(index)"
										icon-pack="feather"
										icon="icon-x"
										color="danger"
										type="flat"
										radius
									></vs-button>
								</div>
							</vx-input-group>
						</vue-perfect-scrollbar>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="data.type === 'anyOf'">
				<div class="vx-col w-full" v-show="enableEdit(data)">
					<div class="mt-4">
						<small class="date-label">{{ $t("Options") }}</small>
						<vue-perfect-scrollbar class="scroll-area--content-options mt-4" :settings="settings">
							<div v-for="(option, index) in data.options_composed" :key="index">
								<div class="flex flex-row justify-content mb-2 w-full">
									<vs-dropdown vs-trigger-click class="cursor-pointer w-full">
										<vs-button
											icon-pack="feather"
											icon="icon-chevron-down"
											color="dark"
											type="border"
											icon-after
											class="w-full"
											>{{ label(option) }}
										</vs-button>

										<vs-dropdown-menu>
											<vs-dropdown-group :vs-label="$t('Object.Basics')">
												<vs-dropdown-item
													v-for="fieldType in composedFieldTypes"
													:key="fieldType.value"
													@click="composedSelectFieldType(fieldType, data, index)"
												>
													<div class="flex flex-wrap items-center">
														<i class="material-icons inline-block mr-2 p-1">
															{{ fieldType.icon }}
														</i>
														<span class="text-lg">{{ fieldType.label }}</span>
													</div>
												</vs-dropdown-item>
											</vs-dropdown-group>
										</vs-dropdown-menu>
									</vs-dropdown>

									<vs-button
										@click="addComposedOption"
										icon-pack="feather"
										size="large"
										icon="icon-plus-square"
										color="dark"
										type="flat"
										class="mr-1 ml-2"
										v-if="index === data.options_composed.length - 1"
									></vs-button>

									<vs-button
										@click="removeOptionComposed(index)"
										icon-pack="feather"
										size="large"
										icon="icon-x-square"
										color="danger"
										type="flat"
										class="ml-1"
										v-show="index > 0"
									></vs-button>
								</div>

								<div class="vx-col w-full mt-2 flex justify-center" v-if="option.type === 'number'">
									<vs-input-number
										v-model.number="option.minimum"
										class="mr-base"
										:label="$t('DesignConfig.MinimumVal') + ':'"
									/>
									<vs-input-number
										v-model.number="option.maximum"
										class="ml-2"
										:label="$t('DesignConfig.MaximumVal') + ':'"
									/>
								</div>

								<div class="vx-col w-full mt-2 flex justify-center" v-if="option.type === 'text'">
									<vs-input-number
										v-model.number="option.minLength"
										class="mr-base"
										:label="$t('DesignConfig.MinimumCharacterLength') + ':'"
									/>
									<vs-input-number
										v-model.number="option.maxLength"
										class="ml-2"
										:label="$t('DesignConfig.MaximumCharacterLength') + ':'"
									/>
								</div>

								<div class="vx-col w-full mt-2 flex justify-center" v-if="option.type === 'boolean'">
									<ul class="flex justify-between">
										<li>
											<vs-checkbox v-model="option.values" :vs-value="true">True</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="option.values" :vs-value="false">False</vs-checkbox>
										</li>
										<li>
											<vs-checkbox v-model="option.values" :vs-value="null">Null</vs-checkbox>
										</li>
									</ul>
								</div>
								<vs-divider class="mt-2 mb-base"></vs-divider>
							</div>
						</vue-perfect-scrollbar>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="data.type === 'select'">
				<div class="vx-col w-full">
					<div class="mt-4" v-show="!enableEdit(data)">
						<small class="date-label">{{ $t("Options") }}</small>
						<ul class="centerx mt-4">
							<li v-for="(option, index) in data.options" :key="index">
								<span class="text-sm">{{ option }}</span>
								<vs-divider class="mt-2 mb-2"></vs-divider>
							</li>
						</ul>
					</div>
				</div>

				<div class="vx-col w-full" v-show="enableEdit(data)">
					<div class="mt-4">
						<small class="date-label">{{ $t("Options") }}</small>
						<vue-perfect-scrollbar class="scroll-area--content-options" :settings="settings">
							<div class="flex mb-1" v-for="(option, index) in data.options" :key="index">
								<vs-input
									v-model="data.options[index]"
									:placeholder="$t('DesignConfig.Option') + ' ' + (index + 1)"
									:value="option"
									@keyup.13="addOption"
									:ref="'option-' + data.id"
									class="w-full mr-1"
								/>
								<vs-button
									@click="removeOption(index)"
									icon-pack="feather"
									icon="icon-x"
									color="danger"
									type="flat"
									radius
								></vs-button>
							</div>
						</vue-perfect-scrollbar>
					</div>
				</div>
			</div>

			<template>
				<vs-divider v-show="enableEdit(data)" />

				<div class="flex justify-end flex-wrap">
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Duplicate')">
							<vs-button
								size="large"
								v-show="enableEdit(data)"
								@click="duplicateProperty(data)"
								icon-pack="feather"
								icon="icon-copy"
								color="dark"
								type="flat"
								radius
							></vs-button>
						</vx-tooltip>
					</transition>
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
							<vs-button
								size="large"
								v-show="enableEdit(data)"
								@click="deleteProperty(data)"
								icon-pack="feather"
								icon="icon-trash-2"
								color="danger"
								type="flat"
								radius
							></vs-button>
						</vx-tooltip>
					</transition>
					<transition name="fade">
						<div class="flex mt-4 ml-base">
							<span class="mr-4" v-show="enableEdit(data)">{{ $t("Object.Required") }}:</span>
							<vs-switch v-show="enableEdit(data)" v-model="data.required" color="success">{{
								$t("Object.Required")
							}}</vs-switch>
						</div>
					</transition>
				</div>
			</template>
		</vx-card>

		<vs-prompt
			:title="$t('Options')"
			class="export-options"
			@cancel="closePrompt"
			@accept="acceptPrompt"
			:accept-text="$t('Accept')"
			:cancel-text="$t('Cancel')"
			@close="closePrompt"
			:active.sync="activeFormatPrompt"
		>
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
		</vs-prompt>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import {v4 as uuidv4} from "uuid";

export default {
	components: {
		VuePerfectScrollbar,
		vSelect,
	},
	props: {
		schema: {
			type: Object,
		},
		addTrigger: {
			type: Number,
		},
		saveTrigger: {
			type: Number,
		},
	},
	data() {
		return {
			selected: {
				label: "",
				name: "",
				required: false,
				type: "text",
				minLength: 2,
				maxLength: 250,
				id: 0,
				options: [],
				options_obj: [],
				options_composed: [],
			},
			configuration: JSON.parse(JSON.stringify(this.schema)),
			properties: [],
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			duplicateCount: 0,
			activeFormatPrompt: false,
			selectedFormat: null,
			formats: [
				{label: this.$t("Status"), value: 1},
				{label: this.$t("DesignConfig.CalendarStatus"), value: 2},
			],
		};
	},
	computed: {
		fieldTypes() {
			return [
				{
					label: this.$t("Object.statusOptions.Text"),
					type: "text",
					icon: "text_format",
				},
				{
					label: this.$t("Object.statusOptions.Number"),
					type: "number",
					icon: "looks_two",
				},
				{
					label: this.$t("Object.statusOptions.Dropdown"),
					type: "select",
					icon: "arrow_drop_down_circle",
				},
				{
					label: this.$t("Object.statusOptions.Radio"),
					type: "radio",
					icon: "radio_button_checked",
				},
				{
					label: this.$t("Object.statusOptions.Checkbox"),
					type: "check",
					icon: "check_box",
				},
				{
					label: this.$t("Object.statusOptions.Checkbox") + " " + "Obj",
					type: "check_obj",
					icon: "check_box",
				},
				{
					label: this.$t("Object.statusOptions.Switch"),
					type: "boolean",
					icon: "toggle_on",
				},
				{
					label: this.$t("Object.statusOptions.Email"),
					type: "email",
					icon: "alternate_email",
				},
				{
					label: this.$t("Object.statusOptions.Url"),
					type: "url",
					icon: "link",
				},
				{
					label: this.$t("Object.statusOptions.Date"),
					type: "date",
					icon: "today",
				},
				{
					label: this.$t("Object.statusOptions.DateTime"),
					type: "hour",
					icon: "schedule",
				},
				{
					label: this.$t("DesignConfig.Composed"),
					type: "anyOf",
					icon: "dashboard",
				},
			];
		},
		composedFieldTypes() {
			return [
				{
					label: this.$t("Object.statusOptions.Text"),
					type: "text",
					icon: "text_format",
				},
				{
					label: this.$t("Object.statusOptions.Number"),
					type: "number",
					icon: "looks_two",
				},
				{
					label: this.$t("Object.statusOptions.Switch"),
					type: "boolean",
					icon: "toggle_on",
				},
			];
		},
		enableEdit() {
			return function name(params) {
				return params.id === this.selected.id;
			};
		},
		icon() {
			return function name(params) {
				return this.fieldTypes.find((t) => t.type === params.type).icon;
			};
		},
		label() {
			return function name(params) {
				return this.fieldTypes.find((t) => t.type === params.type).label;
			};
		},
		calendarLabels() {
			const eventStatus = this.$store.state.moduleSchedule.eventSatusLabels;
			if (!eventStatus || eventStatus.length <= 0) return [];
			else return this.generateOptionSelect(eventStatus, "name", "id", "");
		},
		calendarLabelsScheduleSms() {
			// schedule_sms
			return this.$store.state.moduleSchedule.eventSatusLabels.filter((e) => e.id !== 1);
		},
		statusOptions() {
			if (this.dataSelect === undefined || this.dataSelect === null) return;
			const {status} = this.dataSelect;
			return this.generateOptionSelect(status, "name", "id", "");
		},
		companyStatus() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.status, "name", "id", "");
		},
	},
	methods: {
		addOption() {
			this.selected.options.push("");
			setTimeout(() => {
				this.$refs[`option-${this.selected.id}`][this.selected.options.length - 1].focusInput();
			}, 100);
		},
		addOptionCheckObj() {
			this.selected.options_obj.push({
				label: this.$t("Object.Label"),
				value: this.$t("CompanyConfValueAddLabel"),
			});
			setTimeout(() => {
				this.$refs[`option-label-${this.selected.id}`][this.selected.options_obj.length - 1].focusInput();
			}, 100);
		},
		addComposedOption() {
			this.selected.options_composed.push({
				type: "number",
				minLength: 2,
				maxLength: 250,
				minimum: 0,
				maximum: 1000000,
				values: [],
			});
		},
		removeOption(index) {
			this.selected.options.splice(index, 1);
		},
		removeOptionObj(index) {
			this.selected.options_obj.splice(index, 1);
		},
		removeOptionComposed(index) {
			this.selected.options_composed.splice(index, 1);
		},
		addProperty() {
			const property = {
				label: "",
				name: "",
				required: false,
				type: "text",
				minLength: 2,
				maxLength: 250,
				minItems: 1,
				minimum: 0,
				maximum: 1000000,
				options: [`${this.$t("DesignConfig.Option")} 1`],
				options_obj: [{label: this.$t("Object.Label"), value: this.$t("CompanyConfValueAddLabel")}],
				options_composed: [
					{
						type: "number",
						minLength: 2,
						maxLength: 250,
						minimum: 0,
						maximum: 1000000,
						values: [],
					},
				],
				id: uuidv4(),
			};

			this.properties.push(property);
			setTimeout(() => {
				this.selected = property;
				if (this.properties.length > 0) this.focusInput(this.properties.length - 1);
			}, 100);
		},
		duplicateProperty(property) {
			this.duplicateCount += 1;
			const {
				label,
				name,
				required,
				type,
				minLength,
				maxLength,
				minimum,
				maximum,
				minItems,
				options,
				options_obj,
				options_composed,
			} = property;
			const propertyUpdate = {
				label: label + "_" + this.duplicateCount,
				name: name + "_" + this.duplicateCount,
				required,
				type,
				minLength,
				maxLength,
				minItems,
				minimum,
				maximum,
				options: [...options],
				options_obj: [...options_obj],
				options_composed: [...options_composed],
				id: uuidv4(),
			};
			this.properties.push(propertyUpdate);
			setTimeout(() => {
				this.selected = propertyUpdate;
				this.focusInput(this.properties.length - 1);
			}, 100);
		},
		deleteProperty(property) {
			const index = this.properties.findIndex((element) => element.id === property.id);
			this.properties.splice(index, 1);
			setTimeout(() => {
				this.selected = this.properties[this.properties.length - 1];
				this.focusInput(this.properties.length - 1);
			}, 90);
		},
		handleClickSelect(data) {
			this.selected = data;
		},
		handleChange(e) {
			this.selected.name = e.target.value.toLowerCase().replaceAll(" ", "_");
		},
		selectFieldType(selectFieldType, data) {
			const index = this.properties.findIndex((element) => element.id === data.id);
			this.properties[index].type = selectFieldType.type;
		},
		composedSelectFieldType(selectFieldType, data, i) {
			const index = this.properties.findIndex((element) => element.id === data.id);
			this.properties[index].options_composed[i].type = selectFieldType.type;
		},
		focusInput(index) {
			setTimeout(() => {
				this.$refs["property-label"][index].focusInput();
			}, 200);
		},
		closePrompt() {
			this.selectedFormat = null;
		},
		acceptPrompt() {
			if (this.selectedFormat) {
				if (this.selectedFormat.value === 1) {
					this.selected.options_obj = this.companyStatus;
				} else {
					this.selected.options_obj = this.calendarLabels;
				}
			}
		},
		generateOptionSelect(data, propLabel, propValue, propName) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue], name: d[propName]};
			});
		},
	},
	watch: {
		addTrigger(val) {
			this.addProperty();
		},
		saveTrigger(val) {
			this.$emit("saveEmit", this.properties);
		},
	},
	mounted() {
		if (
			Object.hasOwnProperty.call(this.configuration, "json_properties") &&
			this.configuration.json_properties.length > 0
		) {
			this.properties = this.configuration.json_properties.map((pro) => {
				return {...pro, id: uuidv4()};
			});
		} else {
			this.addProperty();
		}
	},
};
</script>

<style lang="scss" scoped>
.scroll-area--content-options {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 250px;
}
</style>
